module.exports = __webpack_public_path__ + "static/media/contact.92d336fa.png";